export default __webpack_public_path__ + "static/gray-fox-logo-b2e5c7b25780b2c35b3005442de42faa.svg";